// Diagnose Mode: Standalone (Mode 1), VDR-invoked (Mode 2), and VDR multi-session (Mode 3). Shared workflow selectors.
import { createSelector } from '@ngrx/store';
import { WorkflowState } from '../reducers/workflow.reducers';
import { RootState } from '../root/root-state.model';

export const workflowState = (state: RootState) => state.workflow;

export const selectDiagnosisId = createSelector(
  workflowState,
  (state: WorkflowState) => {
    return state.diagnosisId;
  },
);

export const selectSessionStatus = createSelector(
  workflowState,
  (state: WorkflowState) => {
    return state.status;
  },
);

export const selectBlockingInfo = createSelector(
  workflowState,
  (state: WorkflowState) => {
    return {
      sessionId: state.diagnosisId,
      sessionStatus: state.status,
      isBlocking: state.isBlocking,
      modifiedAt: state.modifiedAt,
      modifiedBy: state.modifiedBy,
    };
  },
);

export const selectChallenges = createSelector(
  workflowState,
  (state: WorkflowState) => {
    return [...state.challenges].sort((a, b) => a.name.localeCompare(b.name));
  },
);

export const selectPairChallenges = createSelector(
  workflowState,
  (state: WorkflowState) => {
    return state.pairChallenges;
  },
);

export const selectSubChallenges = createSelector(
  workflowState,
  (state: WorkflowState) => {
    return [...state.subChallenges].sort((a, b) =>
      a.name.localeCompare(b.name),
    );
  },
);

export const selectCurrentSolutionIds = createSelector(
  workflowState,
  (state: WorkflowState) => {
    return state.selectedSolutionIds;
  },
);

export const selectAvailableSolutions = createSelector(
  workflowState,
  (state: WorkflowState) => {
    return state.availableSolutions;
  },
);

export const selectEnteredDataEntries = createSelector(
  workflowState,
  (state: WorkflowState) => {
    return state.enteredDataEntries;
  },
);

export const selectSuggestedDataEntries = createSelector(
  workflowState,
  (state: WorkflowState) => {
    return state.suggestedDataEntries;
  },
);

export const selectRelatedVDRJob = createSelector(
  workflowState,
  (state: WorkflowState) => {
    return state.vdrJob;
  },
);

export const selectIsVDRSession = createSelector(
  workflowState,
  (state: WorkflowState) => {
    return state.isVDRSession;
  },
);

export const selectSolutionReferences = createSelector(
  workflowState,
  (state: WorkflowState) => {
    return state.solutionReferences;
  },
);

export const selectRequiredActions = createSelector(
  workflowState,
  (state: WorkflowState) => {
    return state.requiredActions;
  },
);

export const selectWorkflowError = createSelector(
  workflowState,
  (state: WorkflowState) => {
    return state.error;
  },
);

export const selectDataEntryLoadingState = createSelector(
  workflowState,
  (state: WorkflowState) => {
    return state.isDataEntryLoading;
  },
);

export const selectSolutionLoadingState = createSelector(
  workflowState,
  (state: WorkflowState) => {
    return state.isSolutionLoading;
  },
);
